import React, { createContext, useContext, useState, useCallback } from 'react';

const DinosaurContext = createContext();

export const useDinosaurContext = () => {
  const context = useContext(DinosaurContext);
  if (!context) {
    throw new Error('useDinosaurContext must be used within a DinosaurProvider');
  }
  return context;
};

export const DinosaurProvider = ({ children }) => {
  const [showAdventureDino, setShowAdventureDino] = useState(false);
  const [showSparkles, setShowSparkles] = useState(false);
  const [explosions, setExplosions] = useState([]);

  const triggerEasterEgg = useCallback(() => {
    setShowAdventureDino(true);
    setShowSparkles(true);
    
    // Criar explosões em diferentes posições
    for (let i = 0; i < 8; i++) {
      setTimeout(() => {
        const x = Math.random() * window.innerWidth;
        const y = Math.random() * (window.innerHeight - 200) + 100;
        setExplosions(prev => [...prev, { id: Date.now() + i, x, y }]);
        
        // Remover explosão após 1 segundo
        setTimeout(() => {
          setExplosions(prev => prev.filter(exp => exp.id !== Date.now() + i));
        }, 1000);
      }, i * 200);
    }
    
    setTimeout(() => setShowSparkles(false), 2000);
    setTimeout(() => setShowAdventureDino(false), 4000);
  }, []);

  const value = {
    showAdventureDino,
    showSparkles,
    explosions,
    triggerEasterEgg
  };

  return (
    <DinosaurContext.Provider value={value}>
      {children}
    </DinosaurContext.Provider>
  );
};
